<div class="bg-white rounded-lg h-full w-full border flex flex-col"> 
    <div class="p-5 py-3 flex items-center justify-between border-b capitalize">
        <p class="text-sm font-semibold">communication</p>
        <select *ngIf="filter" class="select select-ghost select-xs" [(ngModel)]="chatBoxType">
            <option value="messages">Messages</option>
            <option value="chats">Chats</option>
            <option value="queries">Queries</option>
        </select>
    </div>

    <!-- Main scrollable container -->
    <div class="flex-1 overflow-hidden">
        <div class="overflow-y-auto h-full min-h-0">
            <!-- Messages -->
            @if (chatBoxType == 'messages') {
                <ul>
                    @for (i of messages; track $index) {
                        <li class="">
                            <a class="hover:bg-zinc-100 p-3 flex items-center">
                                <div class="flex gap-3 items-start w-full">
                                    <div class="w-8 h-8">
                                        @if (i.sender_image) {
                                            <img class="w-full h-full rounded-full object-cover" src="{{i.sender_image}}" alt="">
                                        } @else {
                                            <span class="w-full h-full rounded-full bg-primary-600 text-white flex items-center justify-center">{{i.sender_name[0]}}</span>
                                        }
                                    </div>
                                    <div class="flex-1">
                                        <small class="text-xs text-zinc-500">{{i.date | date:'short'}}</small>
                                        <p class="text-xs line-clamp-2">{{i.message}}</p>
                                        <p class="text-sm font-semibold"><span class="uppercase">{{i.type}}</span> by {{i.sender_name}}</p>
                                    </div>
                                    <div class="text-xs p-2 rounded bg-zinc-100 text-zinc-600 font-semibold">{{i.class}}</div>
                                </div>
                            </a>
                        </li>
                    }
                </ul>
            }
            <!-- Messages -->
            <!-- Chats -->
            @else if (chatBoxType == 'chats') {
                <ul>
                    @for (i of messages; track $index) {
                        <li class="">
                            <a class="hover:bg-zinc-100 p-3 flex items-center">
                                <div class="flex gap-3 items-start w-full">
                                    <div class="w-8 h-8">
                                        @if (i.sender_image) {
                                            <img class="w-full h-full rounded-full object-cover" src="{{i.sender_image}}" alt="">
                                        } @else {
                                            <span class="w-full h-full rounded-full bg-primary-600 text-white flex items-center justify-center">{{i.sender_name[0]}}</span>
                                        }
                                    </div>
                                    <div class="flex-1">
                                        <!-- <small class="text-xs text-zinc-500">{{i.date | date:'short'}}</small> -->
                                        <p class="text-sm font-semibold">{{i.sender_name}} (<span>{{i.class}})</span></p>
                                        <p class="text-xs line-clamp-2">{{i.message}}</p>
                                    </div>
                                    <small class="text-xs text-zinc-500">{{i.date | date}}</small>
                                    <!-- <div class="text-xs p-2 rounded bg-zinc-100 text-zinc-600 font-semibold">{{i.class}}</div> -->
                                </div>
                            </a>
                        </li>
                    }
                </ul>
            }
            <!-- Chats -->
              <!-- Messages -->
            @else if (chatBoxType == 'queries') {
                <ul>
                    @for (i of messages; track $index) {
                        <li class="">
                            <a class="hover:bg-zinc-100 p-3 flex items-center">
                                <div class="flex gap-3 items-start w-full">
                                    <div class="w-8 h-8">
                                        @if (i.sender_image) {
                                            <img class="w-full h-full rounded-full object-cover" src="{{i.sender_image}}" alt="">
                                        } @else {
                                            <span class="w-full h-full rounded-full bg-primary-600 text-white flex items-center justify-center">{{i.sender_name[0]}}</span>
                                        }
                                    </div>
                                    <div class="flex-1">
                                        <small class="text-xs text-zinc-500">{{i.date | date:'short'}}</small>
                                        <p class="text-xs line-clamp-2">{{i.message}}</p>
                                        <p class="text-sm font-semibold"><span class="uppercase">{{i.type}}</span> by {{i.sender_name}}</p>
                                    </div>
                                    <div class="text-xs p-2 rounded bg-zinc-100 text-zinc-600 font-semibold">{{i.class}}</div>
                                </div>
                            </a>
                        </li>
                    }
                </ul>
            }
            <!-- Messages -->
        </div>
    </div>
</div>
